'use client';

import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const QuickShipBanner = () => {
  return (
    <section className="bg-red-600 text-white py-6 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Left: Icon + Headline */}
          <div className="flex items-center gap-4">
            <div className="flex-shrink-0 bg-white/20 rounded-full p-3">
              <Icon name="TruckIcon" size={28} className="text-white" />
            </div>
            <div>
              <p className="text-xs font-semibold uppercase tracking-widest text-red-100 mb-0.5">QuickShip Program</p>
              <h2 className="text-xl md:text-2xl font-bold leading-tight">
                Same-Day Shipping on Top-Selling Parts
              </h2>
            </div>
          </div>

          {/* Center: Stats */}
          <div className="flex items-center gap-6 md:gap-10 text-center">
            <div>
              <p className="text-2xl font-bold">24hr</p>
              <p className="text-xs text-red-100 uppercase tracking-wide">Order Processing</p>
            </div>
            <div className="w-px h-10 bg-white/30 hidden md:block" />
            <div>
              <p className="text-2xl font-bold">Days</p>
              <p className="text-xs text-red-100 uppercase tracking-wide">Not Weeks</p>
            </div>
            <div className="w-px h-10 bg-white/30 hidden md:block" />
            <div>
              <p className="text-2xl font-bold">50 States</p>
              <p className="text-xs text-red-100 uppercase tracking-wide">Nationwide</p>
            </div>
          </div>

          {/* Right: CTA */}
          <Link
            href="/products"
            className="flex-shrink-0 bg-white text-red-600 px-6 py-3 font-bold text-sm tracking-wide hover:bg-red-50 transition-colors whitespace-nowrap flex items-center gap-2"
          >
            <Icon name="BoltIcon" size={16} />
            Browse In-Stock Parts
          </Link>
        </div>
      </div>
    </section>
  );
};

export default QuickShipBanner;
